<template>
  <div class="wrapper">
    <div class="box">
      <h2>Prijava</h2>
      <div class="content">
        <label>Korisničko ime</label>
        <input v-model="username" type="text" autocomplete="username">
        <label>Lozinka</label>
        <input v-model="password" type="password" autocomplete="current-password">
        <span v-if="error" class="error">{{ errorMessage }}</span>
        <button :disabled="loading" @click="login()">Prijavi se</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      username: '',
      password: '',
      error: false,
      errorMessage: '',
      loading: false
    }
  },

  methods: {
    login () {
      this.error = false
      this.errorMessage = ''
      if (!this.username.trim() || !this.password) {
        this.error = true
        this.errorMessage = 'Unesite korisničko ime i lozinku'
        return
      }
      this.loading = true
      axios.post('/api/auth/login', {
        username: this.username.trim(),
        password: this.password
      }).then((res) => {
        const token = res.data && res.data.token
        if (token) {
          localStorage.setItem('token', token)
          this.$emit('login')
        } else {
          this.error = true
          this.errorMessage = 'Neispravni podaci za prijavu'
        }
      }).catch((err) => {
        this.error = true
        this.errorMessage = (err.response && err.response.data && err.response.data.error) || 'Lozinka nije ispravna'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FAFAFA;
  .box {
    width: 100%;
    max-width: 400px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 5px;
    h2 {
      line-height: 50px;
      font-size: 22px;
      border-bottom: 1px solid rgba(0, 0, 0, .1);
      text-align: center;
    }
    .content {
      padding: 30px 50px;
      text-align: center;
      label {
        display: block;
        margin-bottom: 10px;
      }
      input {
        width: 100%;
        height: 30px;
        text-align: center;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, .1);
      }
      .error {
        display: block;
        margin-top: 5px;
        color: rgb(214, 38, 38);
      }
      button {
        padding: 10px 40px;
        border: none;
        background-color: #000;
        color: #fff;
        border-radius: 5px;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
